import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { addMarkupApi } from "src/Api/markupApi/markupApi";
import { decryptData } from "src/utils/decryptcookie";
import { useSnackbar } from "notistack5";
import { getUserById } from "src/Api/AgentApis/GetAgentApi";
import { allowOnlyNumeric } from "src/utils/eventUtils";

const AgentMarkup = ({ handleClose, amount: externalAmount, setAmount: setExternalAmount }) => {
  const [internalAmount, setInternalAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setError] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const userId = decryptData("_b60-g6fr_plus");

  // Use external state if provided, otherwise use internal
  const amount = externalAmount !== undefined ? externalAmount : internalAmount;
  const setAmount = setExternalAmount || setInternalAmount;

  const handleAddMarkup = async () => {
    const apiData = {
      userid: userId?.userid,
      amount: amount,
      token: userId?.token,
      setIsLoading: setIsLoading,
    };
    if (Number(amount) <= 0) {
      enqueueSnackbar("Please Enter Amount", {
        variant: "error",
        onClick: (event, key) => {
          closeSnackbar(key);
        },
      });
      return;
    }
    const response = await addMarkupApi(apiData);
    if (response?.data?.status === true) {
      setAmount(response?.data?.markup);
      handleClose();
      enqueueSnackbar(response?.data?.message, {
        variant: "success",
        onClick: (event, key) => {
          closeSnackbar(key);
        },
      });
    } else {
      enqueueSnackbar(response?.data?.message, {
        variant: "error",
        onClick: (event, key) => {
          closeSnackbar(key);
        },
      });
    }
  };

  const handleAmount = (e) => {
    const { value } = e.target;
    if (Number(value) <= 5000) {
      setAmount(value);
    }
  };

  const userMarkupInfoApi = async () => {
    const { data } = await getUserById(userId?.userid);
    if (data?.baseResponse?.status === 1) {
      setAmount(`${data?.response?.markup || ""}`);
    } else {
      setError(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    userMarkupInfoApi();
  }, []);

  if (isError) {
    return <h2>Unable to show Markup</h2>;
  }

  return (
    <div className="flex flex-col gap-3">
      <TextField
        autoFocus
        onKeyDown={allowOnlyNumeric}
        placeholder="Enter markup amount (max ₹5,000)"
        label="Markup Amount (₹)"
        value={amount}
        required
        fullWidth
        onChange={handleAmount}
        disabled={isLoading}
      />
      <LoadingButton
        size="large"
        type="submit"
        onClick={handleAddMarkup}
        loading={isLoading}
        loadingPosition="end"
        variant="contained"
        fullWidth
      >
        <span>Save Markup</span>
      </LoadingButton>
    </div>
  );
};

export default AgentMarkup;
